import React from 'react'
import { Grid, Box, Typography } from '@mui/material'
import { Link } from 'react-router-dom'
import { KedoContext } from '../model/types'
import { useEnvironmentInfo } from '../hooks/useEnvironmentInfo'

interface Props {
    kedo: KedoContext
}

export const EnvironmentInfo: React.FC<Props> = ({ kedo }) => {
    const {
        environment,
        environmentName,
        logoSrc,
        handleImageError,
        clearEnvironment,
    } = useEnvironmentInfo(kedo)

    return (
        <Grid container className="environmentInfo">
            <Grid size={12}>
                <Box className={'switchSaas'}>
                    <Box
                        component={Link}
                        to="/environment"
                        onClick={clearEnvironment}
                    >
                        <img
                            onError={handleImageError}
                            className="avatar"
                            src={logoSrc}
                            alt={`Logo van ${environment?.name ?? ''}`}
                        />
                    </Box>

                    <Typography
                        component="h6"
                        sx={{ textTransform: 'capitalize', fontWeight: 'bold', mt: 1 }}
                    >
                        {environmentName.slice(0, 25)}
                    </Typography>
                </Box>
            </Grid>
        </Grid>
    )
}
